var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6628 3.08748C12.8906 3.31529 12.8906 3.68463 12.6628 3.91244L5.6628 10.9124C5.435 11.1402 5.06565 11.1402 4.83785 10.9124L1.33785 7.41244C1.11004 7.18463 1.11004 6.81529 1.33785 6.58748C1.56565 6.35967 1.935 6.35967 2.1628 6.58748L5.25033 9.675L11.8378 3.08748C12.0657 2.85967 12.435 2.85967 12.6628 3.08748Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.855df81c363db522c38fea65071a6263.svg";
export { ForwardRef as ReactComponent };